import * as Factory from 'factory.ts'
import faker from 'faker'

import { type V1UserApiModel } from '../V1UserApiModel'

export const V1UserApiModelStub = Factory.Sync.makeFactory<V1UserApiModel>({
  id: Factory.each(() => faker.random.number()),
  user: Factory.each(() => faker.random.number()),
  firstName: Factory.each(() => faker.name.firstName()),
  lastName: Factory.each(() => faker.name.lastName()),
  email: Factory.each(() => faker.internet.email()),
  position: Factory.each(() => faker.name.jobTitle()),
  phone: Factory.each(() => faker.phone.phoneNumber()),
  profile_image: Factory.each(() => faker.image.avatar()),
  slack_user_id: '',
})
